// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__28pE7","created":"Footer_created__3g-n7","heart":"Footer_heart__21Rh7"};